@if (trigger()) {
    <div class="fixed top-0 bg-black/20 flex items-center justify-center z-50 w-full h-full">
        <div class="p-5 flex flex-col gap-5 rounded-lg w-115 bg-white border-border_color border">
            <div class="flex items-center flex-col w-full gap-4">
                <div class="p-3 rounded-full flex items-center justify-center {{ iconBgClass() }}">
                    <img [src]="iconSrc()" alt="" width="24" height="24" />
                </div>
                <div class="flex flex-col gap-2.5">
                    <h2 class="text-lg font-semibold text-center w-full text-text_dark">{{title()}}</h2>
                    <p class="text-center text-sm text-text_gray w-full">{{description()}}</p>
                </div>
            </div>
            <div class="flex items-center gap-4 w-full text-sm">
                <button (click)="onCancel()" class="flex items-center justify-center py-2.5 px-3 gap-1 bg-white border border-border_color rounded-lg flex-1 text-text_dark">
                    <div>
                        <img src="assets/icons/close_dark_icon.svg" alt="" width="20" height="20" />
                    </div>
                    {{ 'common.cancel' | translate }}
                </button>
                <button (click)="onConfirm()" class="flex items-center justify-center py-2.5 px-3 gap-1 rounded-lg flex-1 text-white {{ confirmButtonClass() }}">
                    <div>
                        <img src="assets/icons/check_white_icon.svg" alt="" width="20" height="20" />
                    </div>
                    {{action_state()}}
                </button>
            </div>
        </div>
    </div>
}